<template>
  <div class="terms-conditions">
    <h1
      id="head-title"
      class="page-title text-gradient text-center heading"
      data-aos="fade-right"
      data-aos-easing="ease-in-out-quad"
      data-aos-once="true"
      data-aos-duration="1000"
    >
      Leicester Caribbean Carnival <br />
      <span class="sub-title">Vendor Unit Terms & Conditions</span>
    </h1>

    <ol class="terms-list">
      <li>
        The vendor is responsible for the erection of their unit and for
        providing their own weather-proof awning, covers, electricity supply,
        and any equipment required for use in their pitch.
        <strong
          >Vendors selling food need to ensure their marquees/units are
          fireproof.</strong
        >
      </li>
      <li>
        Any vendor found operating outside of their assigned area as detailed in
        their application form will be asked to adjust to fit their operations
        within the marked-out area allocated to them. This includes the use of
        additional tables, chairs, or other equipment.
      </li>
      <li>
        <strong
          >NO DRINKS ARE TO BE SERVED IN GLASS BOTTLES ON THE GROUNDS.</strong
        >
        All drinks must be served in a paper or plastic cup. Leicester
        Caribbean Community Caribbean Carnival CIO will make a note of all
        vendors observed serving drinks in bottles. They will be cautioned and
        if they continue to do so will not be allowed to continue to trade.
      </li>
      <li>
        <strong>
          THE SALE OF ALCOHOLIC DRINKS IS NOT PERMITTED BY ANY FOOD OR ART &
          CRAFT VENDOR. PLEASE NOTE IT IS A CRIMINAL OFFENCE TO SELL ALCOHOL
          WITHOUT A LIQUOR LICENCE. FAILURE TO COMPLY WILL FORCE US TO CLOSE
          YOUR OPERATIONS WITH IMMEDIATE EFFECT.</strong
        >
      </li>
      <li>
        A copy of a valid risk assessment, Food Hygiene Certificate, and Public
        Liability Insurance covering your operations on the day must be
        submitted to Leicester Caribbean Community Caribbean Carnival CIO at the
        time of registration or at the latest one (1) month before the event.
        This is a requirement for the issuing of vendor units to all traders.
        <strong
          >PLEASE ENSURE THAT YOU TAKE A COPY OF YOUR RISK ASSESSMENT, FOOD
          HYGIENE CERTIFICATE, AND INSURANCE WITH YOU TO THE GROUNDS ON CARNIVAL
          DAY, AS IT IS REQUIRED BY LAW.</strong
        >
        Without such documents, you will not gain access to the area.
      </li>
      <li>
        <strong>
          IT IS THE VENDOR'S RESPONSIBILITY TO HAVE ADEQUATE PUBLIC LIABILITY
          INSURANCE IN RESPECT OF ANY OR ALL ACTIVITIES CARRIED OUT BY THEM IN
          CONNECTION WITH THEIR OPERATIONS.</strong
        >
      </li>
      <li>
        Fire extinguishers are required by Law for all vendor units. All
        barbecues must have safety rails/barriers and be placed a safe distance
        away from the public.
      </li>
      <li>
        The vendor must take all reasonable steps to keep the site and ground in
        the immediate vicinity free from litter and paper, and in proper
        condition.
        <strong
          >At the end of trading, all trade waste must be placed in the bins
          provided and must not be left on the ground. Cooking oil must be
          collected in containers, allowed to cool, and sealed with a cover
          before disposal. Galvanized or other suitable sheeting should be
          placed under BBQ grills and coal pots to collect ashes and coals that
          are likely to fall on the ground below. Please ensure that all coal
          fire is extinguished, allowed to cool, and collected in bags and
          disposed of accordingly.</strong
        >
      </li>
      <li>
        Please be aware that restrictions concerning the movement and parking of
        vehicles will be strictly enforced. Each vendor is entitled to take
        <strong class="underline">ONE MOTOR VEHICLE ONLY</strong> into the
        grounds in connection with their purchase of a Vendor unit.
        <strong
          >Parking will be provided for that vehicle behind your vendor unit.
          Please do not come on the day with extra vehicles as there are no
          additional facilities for parking.</strong
        >
      </li>
      <li>
        <strong>
          All Vendor units must be on the park by 9:00 am at the latest and no
          movement of vehicles after 10:00 am.</strong
        >
        The traffic Department will not allow any vehicle access to the grounds
        or any movement of vehicles on or off the park between the hours of 9:00
        am and 8:00 pm (Except for Emergency purposes).
      </li>
      <li>
        The vendor unit holder will comply with all legal requirements under
        statute, by-laws, or statutory instrument relating to the sale of food
        to the public and acknowledge that Leicester Caribbean Community
        Caribbean Carnival CIO will not be responsible for the supply of such
        items.
      </li>
      <li>
        Vendors are not to exhibit or permit to be exhibited on any part of
        their site advertising boards, posters, notices, or other promotional
        materials except with the written consent of Leicester Caribbean
        Community Caribbean Carnival CIO.
        <strong> Advertising is restricted to your operations only.</strong>
      </li>
      <li>
        <strong>NO PERMISSION HAS BEEN GRANTED BY</strong> Leicester Caribbean
        Community Caribbean Carnival CIO
        <strong>FOR MUSIC TO BE PLAYED FROM ANY VENDOR UNIT</strong>. PRS
        Licenses held by vendors are not valid for use on the grounds. Failure
        to follow the guidelines could result in the vendor being asked to cease
        operations and to vacate the area.
      </li>
      <li>
        All vendors are asked not to put any fresh food on the grill after 7:00
        pm. Please note you are required to cease operations at 7:45 pm and to
        leave the grounds by 9 pm at the latest.
        <strong>THERE WILL BE NO EXCEPTIONS</strong>.
      </li>
      <li>
        All vendor units will be photographed for reference purposes. Vendors
        are not required to be photographed, however, Vendors are required to
        make good any damage caused to the site by their operations.
      </li>
      <li>
        Leicester Caribbean Community Caribbean Carnival CIO will not be liable
        to the applicant for:
        <ul>
          <li>
            Theft, damage, or loss of any property of the Applicant or Vendor
            unit holder however caused.
          </li>
          <li>
            <strong>
              Loss of monies or lack of earnings, caused by inclement weather,
              the position of the Vendor unit or any other cause.</strong
            >
          </li>
          <li>
            Any penalty imposed by anyone due to the applicant/vendor unit
            holder's failure to comply with any statutory requirement concerning
            his or her trading activities.
          </li>
          <li>
            Public Liability Insurance in respect of any or all activities
            carried out by the applicant in connection with his/her Vendor unit.
          </li>
        </ul>
      </li>
      <li>
        Vendors will have access to Victoria Park from 6.00 am on Carnival Day.
        Leicester Caribbean Community Caribbean Carnival CIO reserves the right
        to search all vehicles entering the grounds and may do spot checks on
        units throughout the day to ensure they comply with the regulations.
        Please be advised that alcoholic beverages found in your units will be
        confiscated by the licensing authority, if it exceeds the limit allowed
        for cooking or personal use. Only the goods for sale agreed in this
        document will be allowed.
      </li>
      <li>
        Please note that CCTV cameras are in operation and will be monitored
        closely from central command. In addition, plain clothes officers will
        be in place to monitor all vendor units/pitches.
      </li>
      <li>
        Vendors who have not booked and paid in advance will not be allowed to
        trade on the day. No unit will be reserved in your name without payment
        being made in full.
      </li>
      <li>
        <strong
          >Please note we no longer accept application forms without full
          payment. Vendor units will be allocated on a first come, first paid,
          and first served basis.</strong
        >
      </li>
      <li>
        <strong>
          Leicester Caribbean Community Caribbean Carnival CIO reserves the
          right to refuse access or to remove any vendor that fails to:</strong
        >
        <ul>
          <li>
            Comply with the terms and conditions laid out in this document.
          </li>
          <li>
            Comply with any reasonable request made by Leicester Caribbean
            Community Caribbean Carnival CIO.
          </li>
          <li>
            Operate during hours within the statutory laws / by-laws/guidelines
            that govern cooking and serving hot & cold foods and beverages.
          </li>
          <li>
            If you refuse to operate within the stated guidelines and asked to
            vacate the carnival site you will not be entitled to any refund of
            registration fees. In addition, you and the organization you
            represent will be barred from operating a vendor unit at future
            carnivals.
          </li>
        </ul>
      </li>
      <li>
        Leicester Caribbean Community Caribbean Carnival CIO will not be liable
        to refund any fees for any reason other than the cancellation of the
        Carnival Day event. In this case, an administration charge will be
        deducted from any fees received.
      </li>
    </ol>
    <div class="agreement heading">
      <p>
        I/We agree to abide by the terms and conditions and agree that I/We will
        be responsible for the manner in which our business is conducted from
        my/our Vendor unit.
      </p>
      <p>
        <strong>
          By applying and paying for a pitch you agree to Leicester Caribbean
          Community Caribbean Carnival CIO Terms and Conditions.
        </strong>
      </p>
      <p>
        <strong>
          DEADLINE FOR REGISTRATIONS IS
          <span class="underline">midnight Tuesday 30th June 2026</span>. NO
          LATE REGISTRATIONS WILL BE ACCEPTED.</strong
        >
      </p>
    </div>
    <h1
      id="head-title"
      class="page-title text-gradient text-center heading"
      data-aos="fade-right"
      data-aos-easing="ease-in-out-quad"
      data-aos-once="true"
      data-aos-duration="1000"
    >
      Notes to Official Contract
    </h1>
    <ol class="terms-list">
      <li>
        The conditions contained in the contract form the basis of an Agreement
        between the applicant and Leicester Caribbean Community Caribbean
        Carnival CIO, and the applicant agrees to abide by the conditions stated
        in the contract, and applicant's signature shall be taken as proof of
        the applicant's acceptance of these conditions.
      </li>
      <li>
        Applicant's attention is particularly drawn to
        <strong> Conditions 5 & 6 </strong> in the contract relating to the need
        to present a copy of a valid risk assessment and for each Vendor to
        carry adequate insurance cover for their own activities/trade.
      </li>
      <li>
        The Applicant should keep a copy of this document for reference and
        return the following to us with full payment to: Leicester Caribbean
        Community Caribbean Carnival CIO, African Caribbean Centre, Maidstone
        Road, Leicester LE2 0UA.
        <ul>
          <li>The original copy of the 2026 Vendor Application Form.</li>
          <li>A valid Food Hygiene Certificate (Food Vendors Only).</li>
          <li>
            <strong> Proof of your Food Hygiene Rating</strong>, which must be
            levels 3 to 5
          </li>
          <li>(Food Vendors only).</li>
          <li>
            <strong>Your menu</strong> or list of goods to be sold from your
            unit on the day.
          </li>
          <li>
            A <strong>valid Risk assessment</strong> to cover your operations at
            Victoria Park.
          </li>
          <li>
            <strong>
              Public Liability Insurance valid on Saturday August 1st
              2026</strong
            >
            to cover your operations on the day.
          </li>
        </ul>
      </li>
      <li>
        <strong> Payment can be made to us as follows:</strong>
        <ul>
          <li>By Cheque</li>
          <li>
            Via online banking direct to our account. Account details are as
            follows:
            <ul>
              <li>
                Account name
                <strong>Leicester Caribbean Community Caribbean Carnival CIO</strong>
              </li>
              <li>
                Sort Code: <strong>20-49-17</strong>......Account Number:
                <strong>53849139</strong>
              </li>
            </ul>
          </li>
        </ul>
      </li>
      <p class="underline w-fit">
        <strong>
          Please ensure that you use your name as a reference when paying
          online.</strong
        >
      </p>
      <p class="underline w-fit text-red">
        <strong>
          Please note banks no longer allow you to pay to anyone's account over
          the counter,</strong
        >
      </p>
      <p class="underline w-fit">
        <strong>
          Please do not send any cash to us in the post as we will not take
          responsibility for monies lost in the post.</strong
        >
      </p>
      <li>
        Leicester Caribbean Community Caribbean Carnival CIO is an equal
        opportunity organization. We are asking all vendors to observe our
        policy and refrain from displaying or selling items that may cause
        offence.
      </li>
    </ol>
  </div>
</template>

<script>
export default {
  name: 'TermsConditions',
};
</script>

<style scoped>
.terms-conditions {
  font-family: Arial, sans-serif;
  line-height: 1.6;
  margin: 20px;
  padding-left: 4rem;
  padding-right: 4rem;
  padding-bottom: 6rem;
  width: 75%;
  margin: auto;
  @media (max-width: 1024px) {
    padding-left: 0rem;
    padding-right: 0rem;
    width: 100%;
  }
}

.terms-conditions h1,
.terms-conditions h2 {
  text-align: center;
}

.terms-conditions ol {
  margin: 20px;
}

.terms-conditions ol li {
  margin-bottom: 10px;
}

.terms-conditions .agreement {
  margin-top: 30px;
}

.terms-conditions .agreement p {
  margin: 10px 0;
}

.terms-conditions .signature {
  margin-top: 20px;
}

.terms-conditions .signature p {
  margin: 5px 0;
}
.terms-list {
  padding-top: 2rem;
}

.uppercase {
  text-transform: uppercase;
}
.w-fit {
  width: fit-content;
}
.text-red {
  color: red;
}
.heading {
  padding-left: 2rem;
  padding-right: 2rem;
}
</style>
